import { Injectable, OnInit } from '@angular/core';
import { RequestService } from './request.service';
import { User, Task, Copy } from '../models/user.model';
import { ISaveDataResponse, IInfoUserResponse, ICheckDeduplicateResponse, IFindConsumerResponse,ICacheStatusResponse, IFindCFResponse, IIsExistedResponse,IGetQRCodeResponse,IVerifyMfaResponse, IMergeCustomerResponse } from '../models/response';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class CustomerService implements OnInit {

    constructor(
        protected _requestService: RequestService,
        protected _http: HttpClient) {

        }

    ngOnInit() { }

    loginCustomer(userName, password) {
        this._requestService.makeRequest('rest/customers/authenticate',
            { "user": { "email": userName, "password": password } },
            (data) => {
                if (data.tokenId)
                    localStorage.setItem("BennetToken", JSON.stringify({
                        userName: userName,
                        tokenId: data.tokenId,
                    }))
            }, (error) => {
                console.error({ type: "SERVER", content: error.statusText })
            },
            null,
            false,
            null)
    }

    SaveCustomer(myuser: User, prefix: string, typeRequest: Task,username: string = "",key: string = ""): Promise<any> {
        var user: User = Copy(myuser);
        console.log(user);
        var url = "rest/internal/action/saveCustomerSecKey";
        user.contacts.cellulare = prefix + user.contacts.cellulare;
        if (user.address.cap.length == 4) user.address.cap = "0" + user.address.cap;
        if (!key)  key="";
         var headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Basic ');
        headers = headers.append('Content-Type', 'application/json');
        headers = headers.append('X-OpenAM-Username', username);
        headers = headers.append('X-OpenAM-TokenId', key);
        var params: Object = { "user": user, "typeRequest": typeRequest };
        var paramsJsonStr = JSON.stringify(params);
        var paramsB64 = Buffer.from(paramsJsonStr).toString('base64');
        return new Promise((resolve, reject) => {
            this._http.post(BASE_URL + url, 'params={"params":"' + paramsB64 + '"}', { headers: headers }).timeout(21000)
                .subscribe(
                    (data: ISaveDataResponse) => {
                        resolve(data.message);
                    },
                    error => {
                        reject({ type: "SERVER", content: error.statusText })
                    }
                )
        })
    }
    
    FindConsumer(nome: string = "", cognome: string = "", dataDiNascita: string = "", cf: string = "", codTessera: string = "") {
        nome = nome.trim();
        cognome = cognome.trim();
        codTessera = codTessera.trim();
        cf = cf.trim();
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/findConsumerSecKey',
                { "nome": nome, "cognome": cognome, "dataDiNascita": dataDiNascita ? dataDiNascita : "", "cf": cf ? cf : "", "codTessera": codTessera ? codTessera : "" },
                (data: IFindConsumerResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText });
                },
                null,
                false,
                null)
        })
    }

    CacheStatus() {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/getStatusCache',
                { },
                (data: ICacheStatusResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText });
                },
                null,
                false,
                null,
                10000,
                true,
                false)
        })
    }


    CheckDeduplicate(nome, cognome, fc, dataDiNascita, email, numbero) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/checkDeduplicate',
                {
                    "nome": nome,
                    "cognome": cognome,
                    "cf": fc,
                    "dataDiNascita": dataDiNascita,
                    "email": email,
                    "numero": numbero
                },
                (data: ICheckDeduplicateResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText });
                },
                null,
                false,
                null)
        })
    }

    verifyMfaInApp(tokenid, username, otpCode) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/verifyMfaInApp',
                {
                    "tokenid": tokenid,
                    "username": username,
                    "otpCode": otpCode
                    
                },
                (data: IVerifyMfaResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText });
                },
                null,
                false,
                null)
        })
    }
    getQRCodeMFAInApp(tokenid, username) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/getQRCodeMFAInApp',
                {
                    "tokenid": tokenid,
                    "username": username
                    
                },
                (data: IGetQRCodeResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText });
                },
                null,
                false,
                null)
        })
    }

    FindCF(cf: string) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/findCF', { "cf": cf },
                (data: IFindCFResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText });
                },
                null,
                false,
                null)

        })
    }

    FindCFExt(cf: string, rowIdCustomer: string = "") {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/findCFExt', { "cf": cf, "rowIdCustomer" : rowIdCustomer },
                (data: IFindCFResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText });
                },
                null,
                false,
                null)

        })
    }

    MergeCust(cardAnonimo: string, cardMaster: string = "",rowIdCustomer,key) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/mergeCustomerSecKey', { "cardAnonima": cardAnonimo, "cardMaster" : cardMaster,"rowIdCustomer": rowIdCustomer, "key":key },
                (data: IMergeCustomerResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText });
                },
                null,
                false,
                null)

        })
    }

    VerifyPhoneNumber(phone) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/verifyPhoneNumber', { "phone": phone },
                (data: IIsExistedResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText })
                },
                null,
                false,
                null)
        })
    }
    GetInfoUser(rowIdCustomer: string = "", username: string = "", codtessera = "",key) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/getInfoUserProfileSecKey',
                { "rowIdCustomer": rowIdCustomer, "userName": username, "codTessera": codtessera, "key":key },
                (data: IInfoUserResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText })
                },
                null,
                false,
                null)
        })
    }
    GetInfoUserAuth(rowIdCustomer: string = "", username: string = "", codtessera = "",tokenid, usernameAuth) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/getInfoUserProfileAuth',
                { "rowIdCustomer": rowIdCustomer, "userName": username, "codTessera": codtessera ,"tokenid": tokenid, "usernameAuth": usernameAuth},
                (data: IInfoUserResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText })
                },
                null,
                false,
                null)
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/theme/services/customer.service.ts